import React from 'react';
import Text from '../text/Text';

import './NoticePanel.scss';

interface INoticePanel {
  content: string,
  className?: string,
  isModal?: boolean,
  icon?: string,
  shouldTranslate?: boolean,
  translateWith?: object
  type: 'error' | 'warning' | 'success'
}

const NoticePanel: React.FC<INoticePanel> = React.memo((props: INoticePanel) => {
  const { type, className, content, isModal, icon, shouldTranslate = true, translateWith } = props;

  return (
    <div className={`${className ? className : ''} notice-panel notice-panel--${type} ${isModal ? 'notice-panel--modal' : ''}`}>
      <div className="notice-panel__icon">
        <i className={`${icon ? icon : 'far fa-lightbulb-exclamation'}`} />
      </div>
      <Text
        shouldTranslate={shouldTranslate}
        translateWith={translateWith ? translateWith : {}} 
        className="notice-panel__content" 
        component="p" 
        content={content} 
        noMargin 
      />
    </div>
  );
});

export default NoticePanel;
